import styled from "styled-components";
import { connect } from "react-redux";
import { FlexContainer } from "../../../constants/assets/containers";
import BlankState from "../../Common/BlankState";
import Table from "../../Common/Table";
import { getPath, getReadableDate } from "../../../utils";
import TableFields from "../../../constants/DriverStories/DriverStories.json";
import variables from "../../../constants/assets/variables";
import { bindActionCreators } from "redux";
import * as DriverStoriesActions from "../../../store/actions/DriverStories";
import { isValNull, debounce} from "../../../utils";
import React, { useCallback, useState, useEffect } from "react";


export const RequestType = {
  DELIVERY_PARTNER: "DP Story",
  ZOMATO: "Zomato",
  EXTERNAL_ENTITY: "Brand Story",
};

export const StoryStatus = {
  APPROVED: "Approved",
  REJECTED: "Rejected",
  LIVE: "Live",
  EXPIRED: "Expired",
  DEACTIVATED: "Deactivated",
};

export const MediaType = {
  IMAGE: "Image",
  VIDEO: "Video",
};

const StoriesList = (props) => {
  const { storiesList, handleViewDetails, getExternalEntitiesList} = props;

  const [externalEntities, setExternalEntities] = useState([]);

  const getExternalEntitiesListSync = useCallback(
    debounce(async () => {
      try {
        const data = await getExternalEntitiesList({});
        setExternalEntities(data || []);
      } catch (error) {
        console.error("Error fetching external entities list", error);
        setExternalEntities([]);
      }
    }, 1000),
    []
  );

  useEffect(() => {
    getExternalEntitiesListSync();
  }, [getExternalEntitiesListSync]);

  const getFieldValue = (story, key) => {
    switch (key) {
      case "action":
        return (
          <span
            onClick={() => handleViewDetails(story.storyId)}
            className={"edit-options cursor-pointer"}
          >
            View
          </span>
        );
      case "requesterType":
        return RequestType[story.requesterType];
      case "storyStatus":
        return StoryStatus[story.storyStatus];
      case "mediaType":
        return MediaType[story.mediaType];
      case "requesterId":
        if (story.requesterType === "EXTERNAL_ENTITY") {
          if (externalEntities.length == 0) {
            return story.requesterId;
          }
          return externalEntities.find(
            (entity) => entity.entityId === story.requesterId
          )?.name;
        }
        return story.requesterId;
      default:
        return getPath(story, key, "NA");
    }
  };

  const getStoryDetail = (storiesList) => {
    return (
      <Table
        list={storiesList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    );
  };

  return (
    <StoryListContainer data-testid="storyListContainer">
      {!isValNull(storiesList) ? getStoryDetail(storiesList) : <BlankState />}
    </StoryListContainer>
  );
};

const StoryListContainer = styled.div`
  border: 0.5px solid ${variables.borderColor};
  box-sizing: border-box;
  border-radius: 0.5rem;
`;

const StoriesCard = styled(FlexContainer)`
  padding: 1.5rem;
  border-bottom: 1px solid ${variables.borderColor};
`;

StoriesCard.LeftSection = styled(FlexContainer)`
  img {
    width: 5rem;
    height: 5rem;
    border: 0.5px solid ${variables.borderColor};
    box-sizing: border-box;
    border-radius: 0.5rem;
    object-fit: cover;
  }
`;

StoriesCard.RightSection = styled(FlexContainer)`
  margin-top: 1rem;
  span {
    color: ${variables.buttonColor};
    font-weight: 500;
    cursor: pointer;
  }
`;

const StoriesDetail = styled.div`
  h3 {
    margin: unset;
    margin-bottom: 0.25rem;
    font-weight: 500;
    cursor: pointer;
  }
  p {
    color: #828282;
    font-size: 1rem;
    line-height: 1.4;
  }
`;

function mapStateToProps(state) {}

function mapDispatchToProps(dispatch) {
  return {
    resetState: bindActionCreators(DriverStoriesActions.resetState, dispatch),
    getExternalEntitiesList: bindActionCreators(
      DriverStoriesActions.getExternalEntitiesList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StoriesList);
